import React from 'react';
import { CCard, CCardBody, CButton } from '@coreui/react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { setCustomDestinationModal } from '../../../../actions/subscriber';
import { setFlexibleModal } from '../../../../actions/common';
import { DESTINATION_TYPE } from '../../../../constants/destinations';

const DestinationCustomServerSide = () => {
     const dispatch = useDispatch();

     const onClickCreateButton = () => {
          dispatch(
               setFlexibleModal({
                    show: false,
                    component: '',
               })
          );
          dispatch(setCustomDestinationModal({ show: true, destinationType: DESTINATION_TYPE.SERVER_SIDE }));
     };

     return (
          <div className='listener-item'>
               <CCard className='custom-destination'>
                    <CCardBody>
                         <div className='card-title d-flex justify-content-between w-100'>
                              <div className='d-flex'>
                                   <img src='/assets/icons/listenlayer-favicon.svg' alt='Icon' className='icon-20 mr-2' />
                                   <h4>Custom Server-Side Destination</h4>
                              </div>
                         </div>
                         <div className='card-text h-100'>Send data using Server Side Triggers to any Destination.</div>
                         <div className={`card-icon d-flex justify-content-end`}>
                              <div className='card-header-actions'>
                                   <CButton className='addicon' color='primary' onClick={onClickCreateButton}>
                                        <i className='fal fa-plus mr-1'></i>
                                        Create
                                   </CButton>
                              </div>
                         </div>
                    </CCardBody>
               </CCard>
          </div>
     );
};

DestinationCustomServerSide.propTypes = {
     destinations: PropTypes.array,
};

export default DestinationCustomServerSide;
